<template>
	<div class="incenters">
		<div>
			<Commonbtn backgroundColor="#FFF" v-if="qx.add" title="新增" fontSize="14px" @btnclick="adduser"
				:src="require('@/assets/icon/icon-add.png')">
			</Commonbtn>
			<Commonbtn backgroundColor="#FFF" v-if="qx.update" title="修改" fontSize="14px" :useAutoOptional="false"
				:optional="sbmidarr.length !== 1" @btnclick="update"
				:src="require('@/assets/icon/icon-update.png')">
			</Commonbtn>
			<Commonbtn backgroundColor="#FFF" v-if="qx.del" title="删除" fontSize="14px" @btnclick="del"
				:src="require('@/assets/icon/icon-del.png')">
			</Commonbtn>
			<Commonbtn backgroundColor="#FFF" title="查看" fontSize="14px" @btnclick="Look"
				:src="require('@/assets/icon/look.png')">
			</Commonbtn>
			<Commonbtn backgroundColor="#FFF" title="导出" fontSize="14px" @btnclick="$emit('Export')"
				:src="require('@/assets/icon/daoc.png')">
			</Commonbtn>
			<CommonbtnUpLoad v-if="qx.add" style="display: inline-block;margin-top: 10px;" backgroundColor="#FFF"
				title="导入" fontSize="14px" @getFile="customerImport" types="file"
				:src="require('@/assets/icon/icon-drjys.png')">
			</CommonbtnUpLoad>
			<a class="Dowload" v-if="qx.add" @click="SeconDowload">导入模版下载</a>
		</div>
		<div class="TableWidth">
			<Commontable ref="comtable" @handleSelectionChange="(e) => sbmidarr = e.map(it => it.TOID)"
				@onRowClick="(e) => cusId = e.TOID" colnum="7" :tableData="tableData" :headerData="headerData"
				height="100%" :hasChecked="false">
			</Commontable>
			<div class="pagination">
				<Pagination @handleCurrentChange="handleCurrentChange" @handleSizeChange="handleSizeChange"
					:total="total"></Pagination>
			</div>
		</div>

		<DialogFrom width="550px" :title="EidtTitle" :dialogVisible="dialogVisibles" @cancel="dialogVisibles = false"
			@dialogOK="dialogOK">
			<div class="from">
				<template v-for="(item, index) of fromdataadd">
					<Commondropdownlist ref="addjxa" :btx="item.btx" :radio="item.radio" :widths="item.widths"
						:pt="item.pt" :options="item.options" :inputdata="item.inputdata" :title="item.title"
						:fontSize="item.fontSize" :color="item.color" :event="item.event" :lablewith="item.lablewith"
						:placeholder="item.placeholder" :types="item.types" :inputtype="item.inputtype"
						:width="item.width" :min="item.min" :max="item.max" :checkboxdata="item.checkboxdata"
						:multiple="item.multiple" :disabled="item.disabled" @remoteMethod="remoteMethod">
					</Commondropdownlist>
				</template>
			</div>
		</DialogFrom>

		<DialogFrom width="890px" :title="title" :dialogVisible="dialogVisiblesdrjg" @cancel="canceldrjg"
			@dialogOK="dialogOKdrjg">
			<div class="from">
				<Commontable width="830px" colnum=100 :tableData="tableDatadrjg" height="100%" />
			</div>
		</DialogFrom>

		<Dialog width="420px" title="提示信息" :dialogVisible="dialogVisibledel" @cancel="canceldel" @dialogOK="dialogOKdel"
			:src="require('@/assets/icon/icon-del2.png')">
			<span
				style="display: inline-block;position: absolute; top: 50px; left: 50px; font-size: 14px;color: #666666;">确认要删除吗？</span>
		</Dialog>
	</div>
</template>
<script>
import Commondropdownlist from "../../../../components/common-dropdownlist.vue";
import Commontable from "../../../../components/common-table.vue";
import Commonbtn from "../../../../components/common-btn.vue";
import Pagination from "../../../../components/pagination.vue";
import DialogFrom from "../../../../components/dialog-from.vue";
import fromdata from "../fromData/add";
import Dialog from "../../../../components/dialog.vue";
import CommonbtnUpLoad from "../../../../components/common-upload.vue";
import headerData from "../tableData/headerData";
import utils from "../../../../common/utils";

import {
	GetTechnicalOfficesInfo,
	AddTechnicalOffices,
	EditTechnicalOffices,
	DeleteTechnicalOffices,
	DownloadTechnicalOfficesTemplet,
	ImportTechnicalOffices,
	GetHospitalList
} from "@/api/newsapi";

export default {
	components: {
		Commontable,
		Commonbtn,
		Pagination,
		DialogFrom,
		Commondropdownlist,
		Dialog,
		CommonbtnUpLoad,
	},
	props: {
		tableData: {
			type: Array,
			default: () => [],
		},
		total: {
				type: Number,
				default: 0,
			},
			typeOptions: {
				type: Array,
				default: () => [],
			},
			productLineOptions: {
				type: Array,
				default: () => [],
			}
		},
	data: function () {
		return {
			sbmidarr: [],
			dialogVisibles: false,
			dialogVisibledel: false,
			dialogVisiblesdrjg: false,
			fromdataadd: [],
			tableDatadrjg: [],
			cusinfo: null,
			cusId: "",
			title: "",
			EidtTitle: "",
			headerData: [],
			qus: [],
			qx: {
				add: false,
				update: false,
				del: false,
				browse: false
			},
		}
	},
	mounted() {
		this.headerData = JSON.parse(JSON.stringify(headerData));
		this.fromdataadd = JSON.parse(JSON.stringify(fromdata));
		this.fromdataadd[0].options = this.productLineOptions;
		this.fromdataadd[3].options = this.typeOptions;
		this.QX();
	},
	methods: {
		// 医院远程搜索
		async remoteMethod(query) {
			if (query !== "") {
				let {
					code,
					data
				} = await GetHospitalList({
					HPName: query,
					pageIndex: 1,
					pageSize: 50
				});
				if (code == 0) {
					this.fromdataadd[2].options = data.data.map(item => ({
						key: item.HPID,
						value: item.HPName
					}));
				}
			} else {
				this.fromdataadd[2].options = [];
			}
		},
		// 查看
		Look() {
			if (!this.cusId) {
				this.$message.error("请选择要操作的数据！");
				return;
			}
			this.EidtTitle = "查看";
			this.dialogVisibles = true;
			this.$nextTick(() => {
				this.customerInfo();
			});
		},
		//添加
		adduser() {
			this.cusId = '';
			this.dialogVisibles = true;
			this.EidtTitle = "新增";
			this.$nextTick(() => {
				this.$refs.comtable.$refs.multipleTable.setCurrentRow('');
			})
		},
		// 修改
		update() {
			if (this.sbmidarr.length === 1) {
				this.cusId = this.sbmidarr[0];
				this.dialogVisibles = true;
				this.EidtTitle = "编辑";
				this.$nextTick(() => {
					this.customerInfo();
				});
				return;
			}
			this.$message.error("请选择要操作的数据！");
		},
		del() {
			if (!this.sbmidarr.length) {
				this.$message.error("请选择要删除的数据！");
				return;
			}
			this.dialogVisibledel = true;
		},
		async dialogOKdel() {
			let {
				code,
				message
			} = await DeleteTechnicalOffices({
				IDs: this.sbmidarr,
			});
			if (code == 0) {
				this.$message({
					type: "success",
					message: "删除成功",
				});
				this.sbmidarr = [];
				this.canceldel();
				this.$parent.customerList();
			} else {
				this.$message({
					type: "error",
					message: message,
				});
			}
		},
		canceldel() {
			this.dialogVisibledel = false;
		},
		// 详情
		async customerInfo() {
			let {
				code,
				data
			} = await GetTechnicalOfficesInfo({
				ID: this.cusId,
			});
			if (code == 0) {
				this.$refs.addjxa[0].modelvalue = data.InvClass;
				this.$refs.addjxa[1].modelvalue = data.TOName;
				this.fromdataadd[2].options = [{
					key: data.Hospital,
					value: data.HospitalName
				}];
				this.$refs.addjxa[2].modelvalue = data.Hospital;
				this.$refs.addjxa[3].modelvalue = data.TOType;
				this.$refs.addjxa[4].modelvalue = data.Doctor;
				this.$forceUpdate();
			}
		},
		//弹窗提交
		async dialogOK() {
			if (this.EidtTitle == "查看") {
				this.dialogVisibles = false;
			} else if (this.EidtTitle == "新增") {
				let {
					code,
					message
				} = await AddTechnicalOffices({
					InvClass: this.$refs.addjxa[0].modelvalue,
				TOName: this.$refs.addjxa[1].modelvalue,
					Hospital: this.$refs.addjxa[2].modelvalue,
					TOType: this.$refs.addjxa[3].modelvalue,
					Doctor: this.$refs.addjxa[4].modelvalue,
				});
				if (code == 0) {
					this.$message({
						type: "success",
						message: "新增成功",
					});
					this.$parent.customerList();
					this.dialogVisibles = false;
				} else {
					this.$message({
						type: "error",
						message: message,
					});
				}
			} else {
				let {
					code,
					message
				} = await EditTechnicalOffices({
					TOID: this.cusId,
					InvClass: this.$refs.addjxa[0].modelvalue,
				TOName: this.$refs.addjxa[1].modelvalue,
					Hospital: this.$refs.addjxa[2].modelvalue,
					TOType: this.$refs.addjxa[3].modelvalue,
					Doctor: this.$refs.addjxa[4].modelvalue,
				});
				if (code == 0) {
					this.$message({
						type: "success",
						message: "修改成功",
					});
					this.cusId = '';
					this.$parent.customerList();
					this.dialogVisibles = false;
				} else {
					this.$message({
						type: "error",
						message: message,
					});
				}
			}
		},
		handleCurrentChange(pageindex) {
			this.$emit("handleCurrentChange", pageindex);
		},
		handleSizeChange(paegSzie) {
			this.$emit("handleSizeChange", paegSzie);
		},
		QX() {
			let data = JSON.parse(localStorage.getItem("MenusData"));
			if (data && data.Menus) {
				data.Menus[0].Nodes.map((item, index) => {
					if (item.NodeID == 35) {
						item.Nodes.map((items, indexs) => {
							if (items.NodeID == 1090) {
								this.qus = items.Nodes;
							}
						});
					}
				});
			}

			console.log(1111, this.qus)
			if (this.qus) {
				this.qus.map((item, index) => {
					if (item.NodeName == "add") {
						this.qx.add = true;
					} else if (item.NodeName == "edit") {
						this.qx.update = true;
					} else if (item.NodeName == "delete") {
						this.qx.del = true;
					} else if (item.NodeName == "browse") {
						this.qx.browse = true;
					}
				});
			}
		},
		// 下载导入模板
		async SeconDowload() {
			let {
				data,
				code,
				message
			} = await DownloadTechnicalOfficesTemplet({});
			if (code == 0) {
				window.location.href = data;
			} else {
				this.$message({
					type: "error",
					message: message,
				});
			}
		},
		// 导入
		async customerImport(file) {
			if (file) {
				const loading = this.$loading({
					lock: true,
					text: "上传中...",
					spinner: "el-icon-loading",
					background: "rgba(255,255,255,0.3)",
				});
				let formData = new FormData();
				formData.append("file", file);
				let res = await ImportTechnicalOffices(formData);
				if (res.code == 0) {
					this.$message({
						type: "success",
						message: res.message,
					});
					this.$parent.customerList();
					loading.close();
				} else if (res.code == 101) {
					this.$message({
						type: "warning",
						message: res.message,
					});
					loading.close();
				} else {
					this.dialogVisiblesdrjg = true;
					this.tableDatadrjg = res.data;
					this.title = "导入结果";
					loading.close();
				}
				loading.close();
			}
		},
		canceldrjg() {
			this.dialogVisiblesdrjg = false
		},
		dialogOKdrjg() {
			this.dialogVisiblesdrjg = false
		}
	},
	watch: {
		dialogVisibles: {
			handler(val) {
				if (!val) {
					this.$refs.addjxa.map((item, index) => {
						item.modelvalue = "";
					});
					this.fromdataadd[1].options = [];
				}
			},
			deep: true,
		},
		EidtTitle: {
			handler(newVal, oldVal) {
				if (newVal == "查看") {
					this.fromdataadd.forEach((item, index) => {
						item.disabled = true;
					});
				} else {
					this.fromdataadd.forEach((item, index) => {
						item.disabled = false;
					});
				}
			},
		},
			typeOptions: {
				handler(val) {
					if (this.fromdataadd && this.fromdataadd[3]) {
						this.fromdataadd[3].options = val;
					}
				},
				deep: true,
			},
			productLineOptions: {
				handler(val) {
					if (this.fromdataadd && this.fromdataadd[0]) {
						this.fromdataadd[0].options = val;
					}
				},
				deep: true,
			},
		},
	};
</script>

<style lang="less" scoped>
.incenters {
	height: 100%;

	.pagination {
		display: flex;
		justify-content: center;
		align-items: center;
		margin-top: 16px;
		padding-bottom: 16px;
	}

	.from {
		width: 100%;
	}

	.TableWidth {
		width: 100%;
	}
}

.Dowload {
	color: #e71d43;
	font-size: 14px;
	margin-left: 10px;
	cursor: pointer;
	text-decoration: underline;
}
</style>